export enum DonutChartName {
  ShipmentQty = 'Shipment Qty',
  Received = 'Received',
  Difference = 'Difference',
  DifferenceByStatus = 'Difference By Status'
}

export const DonutChartField = {
  working: {
    displayName: 'Working',
    colorField: '#4B5C6B'
  },
  created: {
    displayName: 'Created',
    colorField: '#4B5C6B'
  },
  shipped: {
    displayName: 'Shipped',
    colorField: '#6558F5'
  },
  inTransit: {
    displayName: 'In Transit',
    colorField: '#F7C325'
  },
  received: {
    displayName: 'Received',
    colorField: '#1AAE9F'
  },
  receiving: {
    displayName: 'Receiving',
    colorField: '#1AAE9F'
  },
  delivered: {
    displayName: 'Delivered',
    colorField: '#897A5F'
  },
  checkedIn: {
    displayName: 'Checked In',
    colorField: '#BD34D1'
  },
  error: {
    displayName: 'Error',
    colorField: '#D3455B'
  },
  null: {
    displayName: 'Null',
    colorField: '#C3CFD9'
  },
}

export class DonutChart {
  type: string;
  value: number;
  colorField: string;

  constructor(type: string, value: number, colorField: string) {
    this.type = type;
    this.value = value;
    this.colorField = colorField;
  }
}
